// extracted by mini-css-extract-plugin
export default {"empty-wrapper":"index_empty-wrapper__sTu8a","image":"index_image__50oeT","back-to-index":"index_back-to-index__ntxKx"};